export default __webpack_public_path__ + "static/media/skull-white.b6f59f7c.png";